module.exports = __webpack_public_path__ + "img/Button-kosik-2021-07.8904b33a.png";